import React from 'react';

/**
 * Horizontal scroll tab row — replaces native <select> for section switching on mobile.
 */
export default function MobileScrollTabs({
  tabs,
  activeId,
  onChange,
  className = '',
  navClassName = '',
  getButtonClassName,
  ariaLabel = 'Sections',
}) {
  return (
    <nav
      className={`flex w-full overflow-x-auto gap-1 p-1 rounded-xl scrollbar-thin touch-manipulation ${navClassName} ${className}`}
      aria-label={ariaLabel}
      style={{ WebkitOverflowScrolling: 'touch' }}
    >
      {tabs.map((tab) => {
        const id = tab.id;
        const isActive = activeId === id;
        const Icon = tab.icon;
        const label = tab.label || tab.shortLabel || tab.mobileLabel || id;
        const base =
          typeof getButtonClassName === 'function'
            ? getButtonClassName(tab, isActive)
            : isActive
              ? 'bg-white text-sky-700 shadow-sm ring-1 ring-sky-100'
              : 'text-slate-600 hover:text-slate-900 hover:bg-white/70';

        return (
          <button
            key={id}
            type="button"
            onClick={() => onChange(id)}
            aria-current={isActive ? 'page' : undefined}
            className={`shrink-0 inline-flex items-center justify-center gap-2 px-3 py-2.5 min-h-[44px] text-sm font-medium rounded-lg transition-all whitespace-nowrap ${base}`}
          >
            {Icon ? <Icon className="w-4 h-4 shrink-0 opacity-80" aria-hidden /> : null}
            <span>{label}</span>
          </button>
        );
      })}
    </nav>
  );
}
